import { connect } from 'react-redux';

import GroupSetsList from './GroupSetsList';

import { selectors as groupSelectors } from '../../../../store/groups';
import { currentUser } from '../../../../../core/selectors/user';
import {
  isInstructor,
  currentClassRoomId as getCurrrentClassRoomId,
} from '../../../../../core/selectors/classroom';

const compareSets = (a, b) => new Date(a.createdAt) - new Date(b.createdAt);

const mapStateToProps = (state) => {
  const user = currentUser(state);
  const isCurrentUserInstructor = isInstructor(state, user.objectId);
  const currentClassRoomId = getCurrrentClassRoomId(state);
  const sets = groupSelectors
    .setsAugmentedWithGroups(state, currentClassRoomId)
    .filter((set) => !set.isHidden || isCurrentUserInstructor)
    .sort(compareSets)
    .map((set) => set.id);

  return {
    loading: state.groups.fetchingGroupSets,
    sets,
  };
};

export default connect(mapStateToProps)(GroupSetsList);
